<div class="animated fadeIn">

<div class="row">

    <div class="col-lg-12">
        <div class="card">
            
            <div class="card-body" style="min-height: 600px;">
             
              <br/>
              <div class="row form-group" >
                <div class="col col-md-12">
                    <div class="card border border-success">
                        <div class="card-header">
                            <div class="row">
                                <div class="col-md-1" style="width: 12.499999995%; flex: 0 0 12.499%;max-width: 12.499%;">
                                    <strong class="card-title">Company List</strong>        
                                </div>
                                <div class="col-md-1" style="width: 12.499999995%; flex: 0 0 12.499%;max-width: 12.499%;">
                                    <input name="compName" [(ngModel)]="compName" placeholder="Name:" id="compName" class="form-control-sm form-control"  />
                                </div>
                                <div class="col-md-2">
                                    <input name="compID" [(ngModel)]="compID" id="compID" placeholder="Comapny ID:" class="form-control-sm form-control"  />
                                </div>
                                <div class="col-md-1" style="width: 12.499999995%; flex: 0 0 12.499%;max-width: 12.499%;">
                                    <input name="compEmail" [(ngModel)]="compEmail" id="compEmail" placeholder="Email:" class="form-control-sm form-control"  />
                                </div>
                                <div class="col-md-2">
                                    <select name="industryType" id="industryType" [(ngModel)]="industryType" class="form-control-sm form-control" >
                                        <option value="">Industry Type:</option>
                                        <option value="">All</option>
                                        <option [value]="idetails" *ngFor="let idetails of industryTypeData">{{idetails}}</option>
                                    </select>
                                </div>
                                <div class="col-md-2">
                                    <select name="peerGroup" id="peerGroup" [(ngModel)]="compPeer" class="form-control-sm form-control" >
                                        <option value="">Peer Group:</option>
                                        <option value="">All</option>
                                        <option value="{{pdetails.peerId}}" *ngFor="let pdetails of peer1Data">{{pdetails.peerGroupName}}</option>
                                    </select>
                                </div>
                                <div class="col-md-1">
                                    <label class="form-control-label"><button type="submit" class="btn btn-primary btn-sm" (click)="searchCompany(1)" ><strong>Search</strong></button></label>
                                </div>
                            </div>
                            
                        </div>
                        <!-- <div class="card-body" > 
                            <div class="row form-group">
                                <div class="col col-md-4">
                                    <label class="form-control-label"><strong>Name:</strong></label>
                                </div>
                                <div class="col col-md-4">
                                    <label class="form-control-label"><strong>Comapny ID:</strong></label>
                                </div>
                                <div class="col col-md-4">
                                    <label class="form-control-label"><strong>Email:</strong></label>
                                </div>
                            </div>
                            <div class="row form-group">
                                <div class="col col-md-4">
                                    <input name="compName" [(ngModel)]="compName" id="compName" class="form-control-sm form-control"  />
                                </div>
                                <div class="col col-md-4">
                                    <input name="compID" [(ngModel)]="compID" id="compID" class="form-control-sm form-control"  />
                                </div>
                                <div class="col col-md-4">
                                    <input name="compEmail" [(ngModel)]="compEmail" id="compEmail" class="form-control-sm form-control"  />
                                </div>
                            </div>
                            <div class="row form-group">
                                <div class="col col-md-4">
                                    <label class="form-control-label"><strong>Industry Type:</strong></label>
                                </div>
                                <div class="col col-md-4">
                                    <label class="form-control-label"><strong>Peer Group:</strong></label>
                                </div>
                                <div class="col col-md-4">
                                    <label class="form-control-label">&nbsp;</label>
                                </div>
                            </div>
                            <div class="row form-group">
                                <div class="col col-md-4">
                                    <select name="industryType" id="industryType" [(ngModel)]="industryType" class="form-control-sm form-control" >
                                        <option value="">All</option>
                                        <option [value]="idetails" *ngFor="let idetails of industryTypeData">{{idetails}}</option>
                                    </select>
                                </div>
                                <div class="col col-md-4">
                                    <select name="peerGroup" id="peerGroup" [(ngModel)]="compPeer" class="form-control-sm form-control" >
                                        <option value="">All</option>
                                        <option value="{{pdetails.peerId}}" *ngFor="let pdetails of peer1Data">{{pdetails.peerGroupName}}</option>
                                    </select>
                                </div>
                                <div class="col col-md-4">
                                    <label class="form-control-label"><button type="submit" class="btn btn-primary btn-sm" (click)="searchCompany(1)" ><strong>Search</strong></button></label>
                                </div>
                            </div>
                        </div> -->
                    </div>
                </div>
              </div>
              <div style="border: 2px solid #dee2e6; padding: 5px;" id="editCont" *ngIf="editVisibility"> 
              	<div class="row form-group">
                                    <div class="col col-md-3"><label for="selectSm" class=" form-control-label">
                                        Company ID
                                    </label></div>
                                    <div class="col-12 col-md-9">
                                        <input name="companyID" [(ngModel)]="companyID" id="companyID" class="form-control-sm form-control" readonly="" />
                                        <input name="companyPid" [(ngModel)]="companyPid" id="companyPid" type="hidden" />
                                    </div>
                                </div>
                                <div class="row form-group">
                                    <div class="col col-md-3"><label for="selectSm" class=" form-control-label">
                                        New Company ID
                                    </label></div>
                                    <div class="col-12 col-md-9">
                                        <input name="companyNewID" [(ngModel)]="companyNewID" id="companyNewID" class="form-control-sm form-control"  />
                                    </div>
                                </div>
                                <div class="row form-group">
                                    <div class="col col-md-3"><label for="selectSm" class=" form-control-label">
                                        Company Name
                                    </label></div>
                                    <div class="col-12 col-md-9">
                                        <input name="companyName" [(ngModel)]="companyName" id="companyName" class="form-control-sm form-control" readonly=""  />
                                    </div>
                                </div>
                                <div class="row form-group">
                                    <div class="col col-md-3"><label for="selectSm" class=" form-control-label">
                                        New Company Name
                                    </label></div>
                                    <div class="col-12 col-md-9">
                                        <input name="companyNewName" [(ngModel)]="companyNewName" id="companyNewName" class="form-control-sm form-control"  />
                                    </div>
                                </div>
                                <div class="row form-group">
                                    <div class="col col-md-3"><label for="file-multiple-input" class=" form-control-label">Logo</label></div>
                                    <div class="col-12 col-md-9"><input type="file" id="cLogo" name="cLogo"  class="form-control-file" accept="image/*" ></div>
                                </div>
                                <div class="row form-group">
                                    <div class="col col-md-3"></div>
                                    <div class="col-12 col-md-6">
                                        <div class="form-actions form-group">
                                            <button type="submit" class="btn btn-primary btn-sm" (click)="updateCompany()" >Update</button>
                                             
                                        </div>

                                    </div>

                                </div>
                </div>
                <table id="bootstrap-data-table" class="table table-striped table-bordered dataTable no-footer" role="grid" aria-describedby="bootstrap-data-table_info">
                        <thead>
                            <tr role="row">
                                <th class="sorting_asc" tabindex="0" aria-controls="bootstrap-data-table" rowspan="1" colspan="1" aria-sort="ascending" aria-label="Name: activate to sort column descending" >Name</th>
                                <th class="sorting" tabindex="0" aria-controls="bootstrap-data-table" rowspan="1" colspan="1" aria-label="Position: activate to sort column ascending" >Code</th>
                                <th class="sorting" tabindex="0" aria-controls="bootstrap-data-table" rowspan="1" colspan="1" aria-label="Office: activate to sort column ascending" >Email</th>
                                <th class="sorting_asc" tabindex="0" aria-controls="bootstrap-data-table" rowspan="1" colspan="1" aria-sort="ascending" aria-label="Month: activate to sort column descending" style="width: 193px;">Creation Date</th>
                                <th>Peer Group</th>
                                <th class="sorting_asc" tabindex="0" aria-controls="bootstrap-data-table" rowspan="1" colspan="1" aria-sort="ascending" aria-label="Status: activate to sort column descending" style="width: 193px;">Status</th>
                               <th class="sorting_asc" tabindex="0" aria-controls="bootstrap-data-table" rowspan="1" colspan="1" aria-sort="ascending" aria-label="Status: activate to sort column descending" style="width: 193px;">Action</th>
                            </tr>
                        </thead>
                        <tbody> 
                        <tr role="row" class="odd" *ngFor="let fdata of peerData">
                            <td class="sorting_1">{{fdata.companyName}}</td>
                            <td>{{fdata.companyCode}}</td>
                            <td>{{fdata.companyEmail}}</td>
                            <td>{{fdata.createDate| date:'dd-MM-yyyy HH:mm:ss'}}</td>
                            <td>{{fdata.peerGroupName}}</td>
                            <td>{{fdata.status?"Active":"Inactive"}}</td>
                          <td>
                           <a (click)="showUpdate(fdata)" class="btn" ><i class="fa fa-pencil"></i></a>
                           <a  style="margin-left: 5px;" (click)="deleteCompany(fdata.companyId)" class="btn"><i class="fa fa-trash"></i></a>
                           </td>
                        </tr> 
                        <tr *ngIf="peerData.length==0"><td colspan="7">No Record Found</td></tr>                                            
                    </tbody>
                </table>
            </div>
        </div>
       

        <div class="row">
                                    <div class="col-sm-12 col-md-5">
                                        <div class="dataTables_info" id="bootstrap-data-table_info" role="status" aria-live="polite">Showing {{(curPage-1)*perPageRow+1}} to {{(curPage-1)*perPageRow+noOfRows}} of {{totalRows}}</div>
                                    </div>
                                    <div class="col-sm-12 col-md-7">
                                        <div class="dataTables_paginate paging_simple_numbers" id="bootstrap-data-table_paginate">
                                            <ul class="pagination">
                                               <!-- <li class="paginate_button page-item previous disabled" id="bootstrap-data-table_previous" (click)="searchFile(curPage-1)" *ngIf="curPage==1">
                                                    <a  aria-controls="bootstrap-data-table" data-dt-idx="0" tabindex="0" class="page-link">Previous</a>
                                                </li>-->
                                                
                                                <li class="paginate_button page-item {{item==curPage?'active':''}}" *ngFor="let item of pages; let i = index" (click)="searchCompany(item)">
                                                    <a  aria-controls="bootstrap-data-table"  class="page-link">{{item}}</a>
                                                </li>
                                                <!--<li class="paginate_button page-item next" id="bootstrap-data-table_next" (click)="searchFile(curPage-1)" >
                                                    <a  aria-controls="bootstrap-data-table" data-dt-idx="7" tabindex="0" class="page-link">Next</a>
                                                </li>-->
                                            </ul>
                                        </div>
                                    </div>
                                </div>
    </div>
</div>
</div><!-- .animated -->

